import type { MailboxInfo } from "owa-client-types";
import { getCalendarConfigurationState } from "./getCalendarConfigurationState";

export function getTxpSettingsStatusCode(mailboxInfo: MailboxInfo): number {
    return getCalendarConfigurationState(mailboxInfo).statusCode;
}
